export enum OrganizationEntitlement {
    Events = 'Events',
    Revenues = 'Revenues',
    Expenses = 'Expenses',
    Donations = 'Donations',
    Sponsors = 'Sponsors',
    Bars = 'Bars',
    Collaborators = 'Collaborators',
    Inventory = 'Inventory',
    Merchandising = 'Merchandising',
}
